import instance from 'api';
import { IOrgStructure, IPositionModel } from 'interfaces';

export const getOrgStructureList = (realEstateGuid: string) => {
  return instance()
    .post<IOrgStructure[]>('/orgStructure/realEstateOrgStructure', { realEstateGuid })
    .then((response) => response.data);
};

// Порядок должностей — общий для всех ЖК (admin_position.sort_order)
export const getPositionsBySortOrder = () => {
  return instance()
    .post<IPositionModel[]>('/dictionary/adminPositions/bySortOrder')
    .then((response) => response.data);
};

export const reorderPositions = (orderedIds: number[]) => {
  return instance()
    .post('/dictionary/adminPositions/reorder', { orderedIds })
    .then((response) => response.data);
};
